import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen } from 'lucide-react';
const chapters = [{
  chapter: 'Chapter 1',
  content: 'The Invisible Bridge: Why Your Knees Hurt in Your Stomach'
}, {
  chapter: 'Chapter 2',
  content: 'Your Pantry Pharmacy: The 10 Ingredients With the Science Behind Them'
}, {
  chapter: 'Chapter 3',
  content: 'The 7-Day Protocol: Complete Menu With Exact Recipes'
}, {
  chapter: 'Chapter 4',
  content: 'Smart Shopping Guide: Where to Buy and What to Avoid'
}, {
  chapter: 'Chapter 5',
  content: 'Movement as Lubricant: 4 Minutes Before You Get Up'
}, {
  chapter: 'Chapter 6',
  content: 'The Maintenance Phase: Lifelong Habits'
}];
export function ProductPresentation() {
  return <section className="bg-cream py-12 md:py-16 px-4 sm:px-6 lg:px-8" data-id="element-132">
      <div className="max-w-6xl mx-auto" data-id="element-133">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-134">
          {/* Left Column - Text */}
          <div className="w-full lg:w-1/2 space-y-10" data-id="element-135">
            <FadeIn data-id="element-136">
              <div className="inline-flex items-center gap-2 bg-forest-green/10 text-forest-green px-4 py-2 rounded-full text-sm font-semibold uppercase tracking-widest mb-4" data-id="element-137">
                <BookOpen className="w-4 h-4" data-id="element-138" />
                Introducing:
              </div>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-forest-green mb-6" data-id="element-139">
                THE SILENT FIRE
              </h2>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-140">
                The complete 55-page manual that teaches you how to put out the
                silent inflammation destroying your joints from the inside,
                using only ingredients from your kitchen
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-141">
              <h3 className="text-xl font-bold mb-6 text-forest-green" data-id="element-142">
                What's inside:
              </h3>
              <div className="space-y-3" data-id="element-143">
                {chapters.map((item, index) => <div key={index} className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 flex items-start gap-4 hover:shadow-md hover:border-sage-green/30 transition-all duration-300" data-id="element-144">
                    <span className="flex-shrink-0 w-10 h-10 rounded-lg bg-forest-green text-white flex items-center justify-center font-bold text-sm" data-id="element-145">
                      {index + 1}
                    </span>
                    <div data-id="element-146">
                      <p className="font-semibold text-forest-green text-sm mb-0.5" data-id="element-147">
                        {item.chapter}
                      </p>
                      <p className="text-gray-600 leading-snug" data-id="element-148">
                        {item.content}
                      </p>
                    </div>
                  </div>)}
              </div>
            </FadeIn>
          </div>

          {/* Right Column - Mockup */}
          <div className="w-full lg:w-1/2 flex justify-center" data-id="element-149">
            <FadeIn delay={0.4} className="w-full max-w-md relative" data-id="element-150">
              {/* Decorative elements */}
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-gold/10 rounded-full blur-2xl" data-id="element-151" />
              <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-sage-green/10 rounded-full blur-2xl" data-id="element-152" />
              <img src="https://cdn.magicpatterns.com/uploads/n9DSYtraSxdLMfSqnxrJrv/MOKUT_THE_SILENT_FIRE.png" alt="The Silent Fire - Ebook cover on tablet" className="w-full h-auto rounded-2xl shadow-2xl relative z-10" data-id="element-153" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}